<template>
  <div>
    <!-- 统计信息卡片 -->
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="always">
          <div slot="header">今日申请人数</div>
          <div class="timu">
            <p>申请人数</p>
            <h2>{{ shenqingNumber }}</h2>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="always">
          <div slot="header">今日到访人数</div>
          <div class="timu">
            <p>到访人数</p>
            <h2>{{ daofangNumber }}</h2>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="always">
          <div slot="header">今日到访单位数量</div>
          <div class="timu">
            <p>到访单位数</p>
            <h2>{{ daofangQiyeNumber }}</h2>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="canvas">
      <!-- 审批记录表格 -->
      <div class="approval-record-title">今日审批通过记录</div>
      <el-table :data="pagedRecords" style="width: 100%">
        <!-- <el-table-column prop="id" label="编号" width="100"></el-table-column> -->
        <el-table-column prop="name" label="访客名字" width="180"></el-table-column>
        <el-table-column prop="phone" label="访客手机号" width="180"></el-table-column>
        <el-table-column prop="qiyeName" label="来访单位" width="180"></el-table-column>
        <el-table-column prop="beifangName" label="接访人名字" width="180"></el-table-column>
        <el-table-column prop="daofangNumber" label="到访人数" width="180"></el-table-column>
        <el-table-column prop="readTime" label="到访时间" width="180"></el-table-column>
        <el-table-column label="操作" width="180">
          <template #default="scope">
            <el-button type="text" @click="viewDetails(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalRecords"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handlePageChange"
      >
      </el-pagination>

      <!-- 查看详情抽屉 -->
      <el-drawer
        title="详细信息"
        :visible.sync="drawerVisible"
        size="50%"
        direction="rtl">
        <el-form label-width="120px" label-position="left">
          <!-- <el-form-item label="编号" style="padding-left: 20px">
            <el-input v-model="detailData.id" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="访客名字" style="padding-left: 20px">
            <el-input v-model="detailData.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="访客手机号" style="padding-left: 20px">
            <el-input v-model="detailData.phone" disabled></el-input>
          </el-form-item>
          <el-form-item label="来访单位" style="padding-left: 20px">
            <el-input v-model="detailData.qiyeName" disabled></el-input>
          </el-form-item>
          <el-form-item label="接访人名字" style="padding-left: 20px">
            <el-input v-model="detailData.beifangName" disabled></el-input>
          </el-form-item>
          <el-form-item label="填写时间" style="padding-left: 20px">
            <el-input v-model="detailData.writeTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="到访时间" style="padding-left: 20px">
            <el-input v-model="detailData.readTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="到访人数" style="padding-left: 20px">
            <el-input v-model="detailData.daofangNumber" disabled></el-input>
          </el-form-item>
          <el-form-item label="到访原因" style="padding-left: 20px">
            <el-input v-model="detailData.reason" disabled></el-input>
          </el-form-item>
          <el-form-item label="访客数字码" style="padding-left: 20px">
            <el-input v-model="detailData.fangkeNumber" disabled></el-input>
          </el-form-item>
          <el-form-item label="访客二维码" style="padding-left: 20px">
            <div class="qr-code">
              <img v-if="detailData.qrCode" :src="'data:image/png;base64,' + detailData.qrCode">
            </div>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shenqingNumber: 0,
      daofangNumber: 0,
      daofangQiyeNumber:0,
      allRecords: [], // 所有数据
      pagedRecords: [], // 当前页的数据
      totalRecords: 0, // 总记录数
      pageSize: 10, // 每页显示的记录数
      currentPage: 1, // 当前页码
      drawerVisible: false, // 控制对话框显示状态
      detailData: {}, // 用于存储当前查看详情的数据
      loading: false // 添加一个loading状态
    };
  },
  created() {
    this.getData();
  },
  methods: {
    viewDetails(row) {
      this.detailData = row; // 将当前行数据赋值
      this.drawerVisible = true; // 显示对话框
      // console.log('row', row);
    },
    getData() {
      this.loading = true; // 开始加载数据
      // 获取当前时间，转换为本地时间格式
      const now = new Date();
      const startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      // 当天的最后一刻（23:59:59.999）
      const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);

      // 格式化时间
      const formatTime = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };

      const startTimeFormatted = formatTime(startTime);
      const endTimeFormatted = formatTime(endTime);

      // 发送请求到后端 API，获得到访人数
      this.$axios.post('/api/get_dayNumber', {
        startTime: startTimeFormatted,
        endTime: endTimeFormatted
      })
      .then(response => {
        this.daofangNumber = response.data.data;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
      
      // 发送请求到后端 API，获得到访人数
      this.$axios.post('/api/get_day_qiye_number', {
        startTime: startTimeFormatted,
        endTime: endTimeFormatted
      })
      .then(response => {
        this.daofangQiyeNumber = response.data.data;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });

      // 发送请求到后端 API,获得所有申请人数
      this.$axios.post('/api/get_shenqing_number', {
        startTime: startTimeFormatted,
        endTime: endTimeFormatted
      })
      .then(response => {
        this.shenqingNumber = response.data.data;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });

      // 发送请求到后端 API,获得审批通过记录每天的
      this.$axios.post('/api/get_all_shenpiAllow_day', {
        startTime: startTimeFormatted,
        endTime: endTimeFormatted
      })
      .then(response => {
        this.allRecords = response.data.data.map(item => {
          if (item.readTime) {
            item.readTime = item.readTime.replace('T', ' ');
          }
          return item;
        });
        this.totalRecords = this.allRecords.length;
        this.updatePagedRecords();
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
    },
    // 更新当前页的数据
    updatePagedRecords() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.pagedRecords = this.allRecords.slice(start, end);
    },
    // 处理分页变化
    handlePageChange(page) {
      this.currentPage = page;
      this.updatePagedRecords();
    }
  }
};
</script>
<style scoped>
.canvas {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 97%;
  position: relative;
}
.el-card {
  margin-bottom: 20px;
  height: 250px; /* 设置固定高度 */
}
.timu {
  font-family: 'Georgia', serif;
  color: #4396e5;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}
.approval-record-title {
  font-family: 'Georgia', serif;
  color: #4396e5;
  font-size: 30px;
  font-weight: bold;
  padding: 15px;
}
</style>